export default {
    "UNPAID": "未支付",
    "PAID": "已支付",
    "SUBMITTED": "已提交",
    "PENDING": "待审核",
    "VERIFIED": "审核通过",
    "REJECTED": "已拒绝",
    "CANCELED": "已取消",
    "DISABLED": "已失效",
    "PENDING_PAY": "部分支付",


    '基础版':'基础版',
    '升级版':'升级版',
    '豪华版':'豪华版',

    'EXPORTED':'已导出',
    'UNEXPORTED':'可导出',
    'APPLYED':'已申请',

    'REFUNDED':'已退款',
    'COMPLETED':'已完成',
    'FINISH':'已失效',
    'ISSUEBILL':'已出保单',
    'POLICY_FAIL':'出单失败',
    'SURRENDERED':'已退保',
    "REFUNDING":"待退款",
}


// WEBPACK FOOTER //
// ./src/i18n/zh-cn/dataI18n/insuranceStatus.js